<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <ProgramReferee/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import ProgramReferee from './components/ProgramReferee'
import Footer from './components/Footer'
export default {
  components: {
    Header,
    ProgramReferee,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramReferee.vue